<template>
  <div class="main">
    <section class="panel panel-default" style="margin-bottom: 0px;">
      <header class="panel-heading" style="padding: 10px;">
        <div class="panel-actions" style="top: 7px;">
          <a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
        </div>
        <h4 class="panel-title">查詢條件</h4>
      </header>
      <div id="searchArea" class="panel-collapse collapse">
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-12 ">
              <div class="col-md-4">
                <label class="col-md-4">起始日期</label>
                <div class="col-md-8">
                  <datepicker :format="customFormatter" :language="zh" v-model="startDate" style="display: inline-block;"/>
                </div>
              </div>
              <div class="col-md-4">
                <label class="col-md-4">結束日期</label>
                <div class="col-md-8">
                  <datepicker :format="customFormatter" :language="zh" v-model="endDate" style="display: inline-block;"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-offset-4 col-md-4 ">
              <div class="col-md-offset-4 col-md-4">
                <button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div id="leaveTypeContent" class="tab-content">
      <div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
        <div class="row form-group">
          <div class="col-md-12 text-right form-inline" v-if="isAdmin('stay')">
            <div class="col-md-6"></div>
            <div class="col-md-6">
              <button class="btn btn-danger hidden-xs" @click="batchDelData" v-if="this.checkedList.length > 0">刪除</button>
              <button class="btn btn-danger btn-block visible-xs" @click="batchDelData" v-if="this.checkedList.length > 0">刪除</button>
              <button class="btn btn-danger hidden-xs" @click="openEditPopup(null)">新增日期時段</button>
              <button class="btn btn-danger btn-block visible-xs" @click="openEditPopup(null)">新增日期時段</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <table class="table table-no-more table-bordered table-striped mb-none">
              <thead>
              <tr>
                <th class="text-center" width="4%" >
                  <input type="checkbox" id="allCheck" name="allCheck" v-model="isAllCheck" @change="allSelection($event)" />
                </th>
                <th class="text-center" width="15%">日期</th>
                <th class="text-center" width="73%">時段</th>
                <th class="text-center" width="8%"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in datePeriodList" :key="index">
                <td data-title="刪除"  class="text-center">
                  <input  type="checkbox" :id="'checkId_'+index" name="checkId" :value="item" v-model="checkedList" @change="checkEvent(item)" />
                </td>
                <td class="text-center" data-title="">{{customFormatter(item.date)}}</td>
                <td class="text-center" data-title="">{{item.periods.join(",")}}</td>
                <td class="text-center" data-title="">
                  <button type="button"  @click="openEditPopup(item)" class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" >編輯</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-12">
            <div class="text-center" v-if="isAdmin('stay')">
              <pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <editPopup v-if="isOpenEditPopup" :data="selected" :is-edit="isEdit" />

  </div>
</template>

<script>
import editPopup from './editPopup';
export default {
  components:{
    editPopup
  },
  data() {
    return {
      page: 1,
      totalPage: 1,
      startDate: '',
      endDate:'',
      datePeriodList: [],
      isAllCheck:false,
      checkedList: [],
      isOpenEditPopup: false,
      selected: null,
      isEdit: false
    }
  },
  mounted() {
    this.updateGrid();
  },
  methods: {
    updateGrid(page = 1) {
      this.page = page;
      const api = "/api/room/getDormitoryLeaveDatePeriod";
      const query = new URLSearchParams({
        startDate: !this.startDate ? '' : this.customFormatter(this.startDate),
        endDate: !this.endDate ? '' : this.customFormatter(this.endDate),
        page: this.page,
        pageSize: 10,
      }).toString();
      this.$axios.get(api + '?' + query).then(resp =>{
        this.datePeriodList = resp.data.data.rows;
        this.totalPage = Math.ceil(resp.data.data.rowNum / resp.data.data.pageSize);
        this.page = resp.data.data.page;
      });
    },
    allSelection(event) {
      this.checkedList = [];
      if(event.target.checked){
        this.checkedList = this.datePeriodList
      }
    },
    checkEvent() {
      this.isAllCheck = this.checkedList.length == this.datePeriodList.length;
    },
    batchDelData() {
      if (!confirm("請問是否確認要刪除勾選的資料？")) return false;
      this.$http.post("/api/room/deleteDormitoryLeaveDatePeriod",
        this.checkedList.map(c => c.date)
      ).then(a => {
        if (a.body.status) {
          alert("刪除成功");
          this.updateGrid();
        } else {
          alert(a.body.msg);
        }
      });
    },
    openEditPopup(item) {
      this.selected = item;
      this.isEdit = !!item
      this.isOpenEditPopup = true;
    }
  }
}
</script>
